import React from "react";
import '../App.css';
import { Button } from "./Button";
import './MainSection.css';

function MainSection() {
  return (
    <div className="main-container">
      <h1>WELCOME</h1>
      <p>Sushi Academy</p>
      <div className="menu-btns">
        <Button className='btns' buttonStyle='btn--outline' buttonSize='btn--large'>Menu</Button>
      </div>
    </div>
  )
}

export default MainSection;